"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Reply = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M18.5,3.9997 C19.327,3.9997 20,4.6727 20,5.4997 L20,5.4997 L20,7.9977 L19,7.9977 L19,5.4997 C19,5.2247 18.776,4.9997 18.5,4.9997 L18.5,4.9997 L5.5,4.9997 C5.224,4.9997 5,5.2247 5,5.4997 L5,5.4997 L5,15.4997 C5,15.7757 5.224,15.9997 5.5,15.9997 L5.5,15.9997 L8.5,15.9997 C8.776,15.9997 9,16.2237 9,16.4997 L9,16.4997 L9,19.9287 L12.105,17.1087 L12.777,17.8487 L9.577,20.7547 C9.399,20.9177 9.175,21.0017 8.947,21.0017 C8.818,21.0017 8.687,20.9747 8.562,20.9197 C8.215,20.7667 8,20.4357 8,20.0567 L8,20.0567 L8,16.9997 L5.5,16.9997 C4.673,16.9997 4,16.3267 4,15.4997 L4,15.4997 L4,5.4997 C4,4.6727 4.673,3.9997 5.5,3.9997 L5.5,3.9997 Z M18.0664,9.1904 L21.3774,12.5014 L18.0664,15.8114 L17.3594,15.1044 L19.4634,13.0004 L15.5004,13.0004 C15.2244,13.0004 15.0004,13.2244 15.0004,13.5004 L15.0004,13.5004 L15.0004,18.0004 L14.0004,18.0004 L14.0004,13.5004 C14.0004,12.6724 14.6724,12.0004 15.5004,12.0004 L15.5004,12.0004 L19.4624,12.0004 L17.3594,9.8974 L18.0664,9.1904 Z", fillRule: "evenodd" })));
};
Reply.displayName = 'Reply';
exports.default = Reply;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Reply.js.map